import React from 'react';
import './style/style.scss'

function Loading() {
  return (
    <div className="spinner-container">
        <div className="spinner"></div>
    </div>
  )
}

export default Loading
